<template lang="pug">
  .component-selectize-driver
    selectize(v-if="options",
      :selectedValue="selectedValue" :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="name",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      placeholder="Document Type")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'

  export default {
    name: 'SelectizeDocumentType',
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>DT${item.id}</small></div><div>${item.name}</div></div>`
      },
      dataLoader(page, resultsPerPage, search) {
        if (this.nullDriver) {
          KeplerBackofficeSdk.documentTypes.list(page, resultsPerPage, search).all((data) => {
            this.options = data
          })
        } else {
          KeplerBackofficeSdk.documentTypes.list(page, resultsPerPage, search).all((data) => {
            this.options = data
          })
        }
      },
      renderTemplate(item, escape) {
        return `<div><div>${item.name}</div></div>`
      }
    },
    props: ['selectedValue']
  }
</script>

<style></style>



// WEBPACK FOOTER //
// SelectizeDocumentType.vue?3c9a2f68